import { Model as s } from "../../../../model.js";
class p extends s {
  constructor(e) {
    super(), this.id = e.id, this.code = e.code, this.scope = e.scope, this.baseRate = e.baseRate, this.status = e.status, this.name = e.name;
  }
}
export {
  p as CashbackConfigurationModel
};
//# sourceMappingURL=cashbackConfiguration.model.js.map
